var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartEmpty = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.98 5.079c-1.238 0-2.412.525-3.302 1.477-1.933 2.068-1.917 5.205.043 7.629 1.683 2.084 7.272 7.41 7.939 7.972 1.19 1.005 1.514 1.006 2.677.029.89-.748 6.234-5.918 7.995-8.022 1.922-2.297 1.934-5.568.026-7.608-.889-.95-2.062-1.474-3.303-1.474h-.001c-1.226 0-2.38.512-3.249 1.441-1.001 1.073-1.34 1.688-1.342 1.695-.28.515-.798.83-1.449.843-.607-.003-1.166-.321-1.44-.838 0 0-.369-.655-1.343-1.7-.872-.931-2.026-1.444-3.25-1.444m2.535 19.382c-.74-.626-6.483-6.08-8.355-8.398-2.92-3.614-2.877-8.365.104-11.555C3.778 2.891 5.806 2 7.98 2c2.16 0 4.17.878 5.663 2.476.133.144.257.281.374.413.118-.13.243-.27.376-.413 1.49-1.595 3.5-2.472 5.66-2.473 2.176 0 4.206.89 5.716 2.505 2.941 3.145 2.978 8.121.089 11.576-1.893 2.262-7.426 7.605-8.384 8.41-1.192 1.003-2.324 1.505-3.455 1.506-1.144 0-2.29-.513-3.503-1.54z"
  })));
};
export default SvgHeartEmpty;